<template>
    <q-card class="my-card" flat>
      <q-item>
        <q-card-section>
            <q-item-section avatar>
            <q-avatar size="50px">
                <img v-if="logo" :src="logoSrc">
                <img src="../assets/icon.png" v-else>
            </q-avatar>
            </q-item-section>
        </q-card-section>
        <q-card-section horizontal>
            <q-item-section>
                <q-item-label class="text-h6">{{name}}</q-item-label>
                <q-item-label>Points to perk: {{pointsToPerk}}</q-item-label>
            </q-item-section>
        </q-card-section>
        <q-space />
        <!--<q-card-section v-if="actions">
            <q-item-section side>
                <q-btn round color="primary" :to="'/merchant/addplace/' + id" icon="edit" />
            </q-item-section>
            <q-item-section side>
                <q-btn round color="red" icon="delete" />
            </q-item-section>
            <q-btn-dropdown
            split
            flat
            push
            no-caps
            dropdown-icon="more_vert"
            >
                <q-list>
                    <q-item clickable v-close-popup @click="selectPlace">
                        <q-item-label>Edit</q-item-label>
                    </q-item>
                    <q-item clickable v-close-popup to="/merchant/plan">
                        <q-item-label>Plan</q-item-label>
                    </q-item>
                    <q-item clickable v-close-popup to="/billing-history">
                        <q-item-label>Subscriptions</q-item-label>
                    </q-item>
                </q-list>
            </q-btn-dropdown>
        </q-card-section>-->
      </q-item>
    </q-card>
</template>
<script>
import router from "@/router";
import { computed } from '@vue/reactivity';
export default {
  name: 'place-card',
  props: ['logo', 'name', 'id', 'actions', 'pointsToPerk'],
  setup(props) {
    const logoSrc = computed(() => process.env.VUE_APP_URL + props.logo.contentUrl)
    const selectPlace = () => {
        router.push('/merchant/addplace/' + props.id)
    }

    return {selectPlace, logoSrc}
  }
}
</script>
